<template>
  <div class="card-single">
    <button
      v-ripple
      v-if="edit"
      type="button"
      class="btn-empty-wrapper mr-5 mb-8"
      @click="clickHandler"
    >
      <Close icon="back" />
    </button>
    <div class="card-place cursor-pointer relative" @click="showEditFields">
      <Ribbon v-if="card.is_default" :card-declined="cardDeclined" />

      <div class="card-pnc relative text-center mb-5 pt-1">
        <span class="text-12 text-label font-bold tracking-normal uppercase">
          {{ card.brand || "" }}
        </span>
        <img
          width="14px"
          height="14px"
          class="card-pnc__edit absolute"
          :src="`${$store.state.appUrl}/img/pwa/icon_edit.svg`"
        />
      </div>
      <span
        class="card-place__icon table mb-2 card-icon"
        v-if="!!card.brand && card.brand === 'visa'"
        ><Visa
      /></span>
      <span
        class="card-place__icon table mb-2 card-icon"
        v-else-if="!!card.brand && card.brand === 'amex'"
        ><Amex />
      </span>
      <span
        class="card-place__icon table mb-2 card-icon"
        v-else-if="!!card.brand && card.brand === 'mastercard'"
        ><Mastercard />
      </span>
      <span
        class="card-place__icon table mb-2 card-icon"
        v-else-if="!!card.brand && card.brand === 'discover'"
        ><Discover />
      </span>
      <span
        class="card-place__icon table mb-2 card-icon"
        v-else-if="!!card.brand && card.brand === 'maestro'"
        ><McIcon />
      </span>
      <span
        class="card-place__icon table mb-2 card-icon"
        v-else-if="!!card.brand && card.brand === 'jcb'"
        ><Jcb />
      </span>
      <div
        class="card-place__number text-16 text-text font-bold tracking-tight"
      >
        **** **** **** <span v-if="!!card.last4">{{ card.last4 }}</span>
      </div>
      <div
        class="card-place__number text-12 text-label font-bold tracking-tight pt-3 flex justify-between"
      >
        <div>
          <div class="text-11 font-normal text-light_grey">
            {{ $t("Card Holder") }}
          </div>
          <div v-if="!!card.holder_name">{{ card.holder_name }}</div>
          <div class="text-center" v-else>---</div>
        </div>
        <div>
          <div class="text-11 font-normal text-light_grey">
            {{ $t("Expires") }}
          </div>
          <div v-if="!!card.expires">{{ card.expires }}</div>
          <div class="text-center" v-else>--</div>
        </div>
      </div>
      <div
        v-if="type === 'bank'"
        class="switcher-container flex justify-between items-center pt-3"
      >
        <span class="text-label text-14 font-bold tracking-normal pr-2"
          >{{ $t("Performance Select Checking") }}
        </span>
        <label
          :for="`donationPause-${index}`"
          class="input-switcher"
          :class="{
            'input-switcher_checked': psc
          }"
        >
          <input
            :id="`donationPause-${index}`"
            type="checkbox"
            v-model="psc"
            @change="savePosActive"
          />
        </label>
      </div>
    </div>
    <div v-if="edit" class="flex-grow flex flex-col">
      <template v-if="editCardFields">
        <div
          class="card-form form-items flex-grow flex flex-col"
          :class="{
            'form-enabled': cardValues.name
          }"
        >
          <FormulateForm
            #default="{ hasErrors }"
            class="flex-grow flex flex-col"
          >
            <div class="form-item-row">
              <FormulateInput
                v-model="cardValues.name"
                type="text"
                name="name"
                :placeholder="$t('Card Holder')"
                validation="required"
              />
            </div>
            <div class="flex">
              <div class="w-4/12">
                <div
                  class="form-item-row"
                  :class="{ empty: !cardValues.month }"
                >
                  <FormulateInput
                    v-model="cardValues.month"
                    :options="optionsMonth"
                    type="select"
                    :placeholder="$t('Select an type')"
                    validation="required"
                  />
                </div>
              </div>
              <div class="w-1/12"></div>
              <div class="w-7/12">
                <div class="form-item-row" :class="{ empty: !cardValues.year }">
                  <FormulateInput
                    v-model="cardValues.year"
                    :options="optionsYear"
                    type="select"
                    :placeholder="$t('Select an type')"
                    validation="required"
                  />
                </div>
              </div>
            </div>
            <div class="form-item-row flex-grow flex flex-col justify-end">
              <FormulateButton
                :form-handler="formHandler"
                :has-errors="hasErrors"
                :title="$t('Edit')"
              />
            </div>
          </FormulateForm>
        </div>
      </template>

      <template v-else>
        <div
          class="switcher-container flex justify-between items-center pt-2 mb-10"
        >
          <span class="text-text text-20 font-bold tracking-normal pr-2"
            >{{ $t("Set card as default") }}
          </span>
          <label
            :for="`defaultCard-${index}`"
            class="input-switcher"
            :class="{
              'input-switcher_checked': !!card.is_default
                ? card.is_default
                : false
            }"
          >
            <input
              :id="`defaultCard-${index}`"
              type="checkbox"
              v-model="card.is_default"
              @change="saveAsDefault"
            />
          </label>
        </div>
        <div
          class="flex justify-between i
                tems-center pb-8"
        ></div>
        <div
          class="flex justify-between i
                tems-center pb-8"
        >
          <span class="text-text text-20 font-bold tracking-normal pr-2"
            >{{ $t("Edit") }}
          </span>
          <button
            v-ripple
            type="button"
            @click="editCardFields = true"
            class="btn-link"
          >
            <EditIcon />
          </button>
        </div>
        <div class="card-delete flex justify-between items-center pt-6">
          <span class="text-error text-20 font-bold tracking-normal pr-2"
            >{{ $t("Delete card") }}
          </span>
          <button
            type="button"
            class="btn-link"
            @click="$setState('setConfirmModal', true)"
          >
            <DeleteIcon />
          </button>
        </div>
      </template>
    </div>
    <ConfirmModal
      content="Would you like to delete this card?"
      @yes="deleteCard"
      @no="$setState('setConfirmModal', false)"
    />
  </div>
</template>

<script>
import EditIcon from "../Icons/EditIcon";
import DeleteIcon from "../Icons/DeleteIcon";
import Close from "../UI/Close";
import FormulateButton from "../UI/FormulateButton";
import McIcon from "../Icons/McIcon";
import Visa from "../Icons/Visa";
import Amex from "../Icons/Amex";
import Mastercard from "../Icons/Mastercard";
import Discover from "../Icons/Discover";
import Maestro from "../Icons/Maestro";
import Jcb from "../Icons/Jcb";
import Ribbon from "../UI/Ribbon";
import ConfirmModal from "../Modal/ConfirmModal.vue";
export default {
  name: "CardItem",
  components: {
    Ribbon,
    Jcb,
    Maestro,
    Discover,
    Mastercard,
    Amex,
    Visa,
    McIcon,
    FormulateButton,
    Close,
    DeleteIcon,
    EditIcon,
    ConfirmModal
  },
  props: ["card", "index", "edit", "clickHandler", "type"],

  data: function() {
    return {
      editFields: false,
      editCardFields: false,
      psc: false,
      cardValues: {
        name: "",
        payment_method_id: "",
        month: "",
        year: ""
      },
      cardDate: "",
      currentYear: "",
      optionsMonth: {
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
        "10": "10",
        "11": "11",
        "12": "12"
      },
      optionsYear: {},
      period: 30
    };
  },

  mounted() {
    this.cardValues = {
      payment_method_id: this.index,
      name: this.card.holder_name,
      month: this.card.exp_month,
      year: this.card.exp_year
    };
    this.generateYears();
  },
  computed: {
    cardDeclined() {
      return (
        this.$getState("isCardDeclined") &&
        this.$getState("isCardDeclined") == this.index
      );
    }
  },

  methods: {
    generateYears: function() {
      const currentYear = new Date().getFullYear();
      for (let i = 0; i < this.period; i++) {
        let year = currentYear + i;
        this.optionsYear[year] = year;
      }
    },

    showEditFields: function() {
      if (this.cardDeclined) return;
      if (!this.edit && this.$route.path !== "/login") {
        this.$emit("actionWithCard", {
          action: "openEdit",
          card: this.card,
          index: this.index
        });
      }
    },
    deleteCard: function() {
      this.$setState("setConfirmModal", false);
      this.$emit("actionWithCard", {
        action: "delete",
        index: this.index
      });
    },
    saveAsDefault: function() {
      this.$emit("actionWithCard", {
        action: "saveDefault",
        index: this.index
      });
      if (this.$getState("isCardDeclined")) {
        this.$emit("actionWithCard", {
          action: "delete",
          index: this.$getState("isCardDeclined")
        });
      }
    },
    savePosActive: function() {
      this.$emit("actionWithCard", {
        action: "savePos",
        index: this.card.pos_id
      });
    },
    formHandler: function() {
      this.$http.post("user/editcard", this.cardValues).then(data => {
        if (data && data.status !== undefined && data.status) {
          this.card.holder_name = this.cardValues.name;
          this.card.exp_year = this.cardValues.year;
          this.card.exp_month = this.cardValues.month;
          this.card.expires =
            this.cardValues.month + " / " + this.cardValues.year;
          this.$emit("close");
        }
      });
    }
  }
};
</script>
